<template>
    <!-- In order to implement the "close when clicking outside this component"
         functionality, we add a mousedown listener to the window and prevent
         clicks on this component from going through (w/ @mousedown.stop). -->
    <div
        class="forum-share"
        @mousedown.stop="">
        <input
            readonly
            ref="input"
            type="text"
            :value="value">
        <button
            title="Copy"
            @click="copy()">
            <i class="fa fa-clipboard"></i>
        </button>
    </div>
</template>

<script>
    // ForumShare: a tiny component that allows the user to copy a URL to a
    // post, thread, or other resource.

    // Events:
    //  - close: convenience event to signal that the user tried to close the
    //           component. This component is likely to be used as a popup after
    //           after clicking on a "Share" button, so rather than implementing
    //           this functionality everywhere it's used, you can just react to
    //           this event (or ignore it).

    import toastr from 'toastr';

    export default {

        props: {
            value: {
                type: String,
            },
        },

        mounted() {
            window.addEventListener('keyup', this.onKeyUp);
            window.addEventListener('mousedown', this.onMouseDown);
        },

        beforeDestroy() {
            window.removeEventListener('keyup', this.onKeyUp);
            window.removeEventListener('mousedown', this.onMouseDown);
        },

        methods: {
            onKeyUp(ev) {
                if (ev.key === 'Escape') {
                    ev.preventDefault();
                    this.close();
                }
            },

            onMouseDown(ev) {
                this.close();
            },

            close() {
                this.$emit('close');
            },

            highlight() {
                this.$refs.input.focus();
                this.$refs.input.select();
            },

            copy() {
                this.highlight();

                // TODO: this method of copying text is deprecated, but it's
                // easy to implement and has awesome browser support; take the
                // time to replace it with the Clipboard API later.
                const success = document.execCommand('copy');

                if (success) {
                    toastr.success('Copied to clipboard');
                } else {
                    toastr.error('Failed to copy to clipboard');
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .forum-share {
        background: #333;
        display: flex;
        padding: 8px;
        max-width: 300px; // temp
    }

    input {
        background: #1e1e1e;
        color: #c0c0c0;
        width: 100%;
        height: 28px;
        line-height: 28px;
        padding: 0 5px;
    }

    button {
        background: #484848;
        border: none;
        color: #c0c0c0;
        padding: 0 5px;
        height: 28px;
        min-width: 28px;
        line-height: 28px;
        margin-left: 8px;

        &:hover {
            background: #555;
        }
    }
</style>



// WEBPACK FOOTER //
// share.vue?6599fcee